import { useReducer } from 'react';

const useBroadcast = (name, initialState) => {
	const reducer = (state, action) => {
		switch (action.type) {
			case 'set':
				return action.value;
			default:
				throw new Error();
		}
	};

	const [state, dispatch] = useReducer(reducer, initialState);
	const channel = new BroadcastChannel(name);

	channel.onmessage = (event) => {
		event.preventDefault();
		const { data: value } = event;
		dispatch({ type: 'set', value });
	};

	function setState(value) {
		channel.postMessage(value);
		dispatch({ type: 'set', value });
	}

	return [state, setState];
};

export default useBroadcast;
